import styled from "styled-components";
import { ButtonCommonProps } from "./types";
import { KeyColors } from "@/theme/colors";
import { onClickWithAnalytics } from "./common";

export enum ButtonIconSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

interface ButtonIconProps extends Omit<ButtonCommonProps, "text"> {
  icon: React.ReactNode;
  $backgroundColor?: KeyColors;
  $borderColor?: KeyColors;
  $iconColor?: KeyColors;
  size?: ButtonIconSize;
  text?: string;
  analyticsContext?: Record<string, unknown>;
}

/**
 * Styled Components
 */

export const StyledButtonIcon = styled.button<{
  $backgroundColor: KeyColors;
  $borderColor: KeyColors;
  $iconColor: KeyColors;
  size: ButtonIconSize;
}>`
  ${({
    theme,
    $backgroundColor: backgroundColor,
    $borderColor: borderColor,
    $iconColor: iconColor,
    size,
  }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${
      size === ButtonIconSize.SMALL
        ? "30px"
        : size === ButtonIconSize.MEDIUM
        ? "40px"
        : "50px"
    };
    height: ${
      size === ButtonIconSize.SMALL
        ? "30px"
        : size === ButtonIconSize.MEDIUM
        ? "40px"
        : "50px"
    };
    border-radius: 50%;
    background-color: ${theme.Colors[backgroundColor]};
    border: 2px solid ${theme.Colors[borderColor]};
    :hover {
      background-color: ${theme.Colors[backgroundColor]};
      color: ${theme.Colors[iconColor]};
      opacity: 0.8;
    }

    :disabled {
      opacity: 0.5;
    }
    svg {
      width: ${
        size === ButtonIconSize.SMALL
          ? "15px"
          : size === ButtonIconSize.MEDIUM
          ? "20px"
          : "25px"
      };
      height: ${
        size === ButtonIconSize.SMALL
          ? "15px"
          : size === ButtonIconSize.MEDIUM
          ? "20px"
          : "25px"
      };
      color: ${theme.Colors[iconColor]};
    }
  `}
`;

/**
 * ButtonIcon Component
 */

export const ButtonIcon = ({
  disabled = false,
  onClick,
  testId,
  text,
  icon,
  size = ButtonIconSize.MEDIUM,
  $backgroundColor: backgroundColor = "yellow500",
  $borderColor: borderColor = backgroundColor,
  $iconColor: iconColor = "white",
  type = "button",
  analyticsContext,
  ...rest
}: ButtonIconProps) => (
  <StyledButtonIcon
    disabled={disabled}
    data-testid={testId}
    onClick={() =>
      onClickWithAnalytics(onClick, {
        button_text: text,
        button_type: type,
        ...analyticsContext ?? {},
      })
    }
    type={type === "restart" ? "reset" : type}
    $backgroundColor={backgroundColor}
    $borderColor={borderColor}
    $iconColor={iconColor}
    size={size}
    {...rest}
  >
    {icon}
    {text}
  </StyledButtonIcon>
);
